import { FC } from 'react';
import { useGetIndividualStoreLogs } from './hooks/useGetIndividualStoreLogs';
import { useStorePaymentLogStoreName } from './hooks/useStorePaymentLogStoreName';
import { IndividualStoreLogTable } from './table';

interface IndividualStoreLogPageProps {
  storeId: string;
}

export const IndividualStoreLogPage: FC<IndividualStoreLogPageProps> = ({ storeId }) => {
  const { individualStoreLogs, isLoading, pagination } = useGetIndividualStoreLogs(storeId);
  const { displayName } = useStorePaymentLogStoreName(storeId);

  return (
    <div className="flex flex-col gap-4">
      <IndividualStoreLogTable
        data={individualStoreLogs}
        isLoading={isLoading}
        pagination={pagination}
        storeName={displayName}
      />
    </div>
  );
};
